import request from "@/utils/request";

export function upload(formData){
  let options = {
    baseURL: process.env.VUE_APP_TASK_BAR_UPLOAD_API,
    url:"/new/common/upload",
    method:"POST",
    headers:{
      'Accept': '*/*',
    },
    data: formData,
    timeout: 20000
  };
  // if(process.env.NODE_ENV === "development") {
  //   options.headers.Authorization = "Bearer eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6Ijk0ZmQyMWQyLWFhNmYtNDZlNi1hZjI0LTE2YThjMmMwYTM0NSJ9.xRYbDOXeLJo6WGMvYHrZjstlr5usObf5CrqamRVR6wZjw5yA1EMsH8-c3V5FPKSRMRGuEf9vVjTqvl_Q0l5hkQ";
  // }
  return request(options);
}